module.exports = __webpack_public_path__ + "8752853c28f0a87ccefb8128bd51c142.svg";